import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 24px 24px 24px;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: left;
`;

export const ModalSubtitle = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[40]};
    margin: 0;
  `}
`;

export const InputWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;

    span {
      font-size: ${theme.v3.font.sizes.mini};
      padding-left: 16px;
      color: ${theme.v3.colors.neutral[60]};
    }
  `};
`;

export const TextAreaWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  span {
    display: none;
  }
`;

export const Label = styled.label`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
    align-self: flex-start;
  `};
`;

export const ModalButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column-reverse;
      align-items: stretch;
    }
  `}
`;
